import { Fragment, useState } from "react";
import "./App.css";
import TodoContainer from "./Components/Todo/TodoContainer";
import { backgrounds } from "./Data/Backgrounds";
import Loader from "./Components/Loader";
import Greeting from "./Components/Greeting";

function App() {
  const [loading, setLoading] = useState(false);
  const date = new Date();
  return (
    <div
      style={{
        backgroundImage: `url(${backgrounds[date.getDate()]})`,
        height: "100vh",
        padding: "5px",
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <TodoContainer />
          <Greeting setLoading={setLoading} />
        </Fragment>
      )}
    </div>
  );
}

export default App;
